import { render, staticRenderFns } from "./UsersSelector.vue?vue&type=template&id=64fe178a"
import script from "./UsersSelector.vue?vue&type=script&lang=js"
export * from "./UsersSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64fe178a')) {
      api.createRecord('64fe178a', component.options)
    } else {
      api.reload('64fe178a', component.options)
    }
    module.hot.accept("./UsersSelector.vue?vue&type=template&id=64fe178a", function () {
      api.rerender('64fe178a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/overlay/UsersSelector.vue"
export default component.exports